export interface SidebarLink {
  id?: number;
  text: string;
  path: string;
  icon?: string;
  parentId?: number;
}

export const SidebarNoAuthLinks: SidebarLink[] = [
  { icon: 'k-i-login', text: 'login', path: '/auth/login' },
  { icon: 'k-i-accessibility', text: 'register', path: '/auth/register' },
  {
    icon: 'k-i-reload',
    text: 'forgot_password',
    path: '/auth/forgot-password',
  },
];

export const SidebarClientLinks: SidebarLink[] = [
  { id: 1, icon: 'k-i-user', text: 'profile', path: '/profile' },
  { id: 2, icon: 'k-i-tell-a-friend', text: 'staff', path: '/staff' },
  { id: 3, icon: 'k-i-plus-outline', text: 'sick_leave', path: '' },
  {
    id: 4,
    parentId: 3,
    icon: 'k-i-plus-outline',
    text: 'sick_leave',
    path: '/sick-leave',
  },
  {
    id: 5,
    parentId: 3,
    icon: 'k-i-chart-line-stacked',
    text: 'sick_leave_analysis',
    path: '/medical-examine',
  },
  { id: 6, icon: 'k-i-file-txt', text: 'telk', path: '/telk-decision' },
  {
    id: 7,
    icon: 'k-i-tell-a-friend-box',
    text: 'new_worker',
    path: '/new-worker',
  },
  //{ id: 7, icon: 'k-i-table-align-top-center', text: 'mail', path: '/mail' },
  {
    id: 8,
    icon: 'k-i-file-txt',
    text: 'PRODUCTION_CHARACTERISTIC',
    path: '/characteristic',
  },
  { id: 9, icon: 'k-i-file-txt', text: 'documents', path: '/documents' },
  { id: 11, icon: 'k-i-logout', text: 'logout', path: '/auth/logout' },
];

export const SidebarStaffClientLinks: SidebarLink[] = [
  { id: 1, icon: 'k-i-user', text: 'profile', path: '/profile' },
  { id: 2, icon: 'k-i-tell-a-friend', text: 'staff', path: '/staff' },
  { id: 3, icon: 'k-i-plus-outline', text: 'sick_leave', path: '' },
  {
    id: 4,
    parentId: 3,
    icon: 'k-i-plus-outline',
    text: 'sick_leave',
    path: '/sick-leave',
  },
  {
    id: 5,
    parentId: 3,
    icon: 'k-i-chart-line-stacked',
    text: 'sick_leave_analysis',
    path: '/medical-examine',
    },
  { id: 8, icon: 'k-i-graph', text: 'QUERIES', path: '' },
  { id: 21, icon: 'k-i-graph', text: 'QUERIES', path: '/queries', parentId: 8 },
  { id: 22, icon: 'k-i-graph', text: 'SENТMAILS', path: '/sentmails', parentId: 8 },
  { id: 23, icon: 'k-i-graph', text: 'COMPANIES', path: '/companies', parentId: 8 },

  { id: 9, icon: 'k-i-file-txt', text: 'telk', path: '/telk-decision' },
  {
    id: 10,
    icon: 'k-i-tell-a-friend-box',
    text: 'new_worker',
    path: '/new-worker',
  },
  { id: 11, icon: 'k-i-file-txt', text: 'documents', path: '' },
  {
    id: 12,
    parentId: 11,
    icon: 'k-i-file-txt',
    text: 'sent_emails',
    path: '/sent-mail',
  },
  { id: 13, parentId: 11, icon: 'k-i-file-txt', text: 'firms', path: '/firms' },
  {
    id: 14,
    parentId: 11,
    icon: 'k-i-file-txt',
    text: 'unoccupied_quotas',
    path: '/freequotes',
  },
  {
    id: 18,
    icon: 'k-i-file-txt',
    text: 'PRODUCTION_CHARACTERISTIC',
    path: '/characteristic',
  },
  {
    id: 15,
    parentId: 11,
    icon: 'k-i-file-txt',
    text: 'documents',
    path: '/documents',
  },
  { id: 16, icon: 'k-i-plus-outline', text: 'mail', path: '' },
  { id: 17, icon: 'k-i-logout', text: 'logout', path: '/auth/logout' },
  {
    id: 19,
    parentId: 16,
    icon: 'k-i-file-txt',
    text: 'mail',
    path: '/mail',
  },
  {
    id: 20,
    parentId: 16,
    icon: 'k-i-file-txt',
    text: 'MAIL_CAMPAIGN',
    path: '/mail-campaign',
  },
];

export const SidebarAdminLinks: SidebarLink[] = [
  { text: 'admin', path: '/admin' },
];
